import { Link } from 'react-router-dom';
import styles from './mainSliderCard.module.css';

export const MainSliderCard = ({ title, price, devices, lang, img, itemId, price_disc }) => {

	const schema = sessionStorage.getItem('schema');

	return (
		<Link to={schema !== 'PS_sharing' ? `/items/${itemId}` : `/PS_sharing/items/${itemId}`}>
			<div style={{
				backgroundImage: `
      linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
			linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent),
      url(${img})
    `,
			}} className={styles.main}>
				<div></div>
				<div className={styles.description_block}>
					<h3 className={styles.title}>{title}</h3>
					<div className={styles.price}>
						{price_disc ? (
							<>
								<span className={styles.price_amount}>{price} ₽</span>
								<p style={{color: 'red'}} className={styles.end_price}>{price_disc} ₽</p>
							</>
						) : <span className={styles.end_price}>{price} ₽</span>
					}
					</div>
				</div>
			</div>
		</Link>
	);
};
